<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="emojiPicker" @blur.self="e => onBlur(e.relatedTarget)" tabindex="0">
    <!--카카오 채널일 때 노출되는 버튼-->
    <v-btn flat icon color="#FFFFFF"
           class="iconBtn"
           slot="activator"
           v-if="channelName === 'KAKAO_TALK'"
           :style="{opacity: isPermission || 0.3}"
           :disabled="!isPermission"
           @click="togglePopover">
      <tooltip
        :text="tooltipContent"
        :is-icon="true"
        alignment="top"
        classes="UXicon-rest emojiTooltip"/>
    </v-btn>
    <!--라인 채널일 때 노출되는 버튼-->
    <v-btn flat icon color="#FFFFFF"
           class="iconBtn"
           slot="activator"
           v-else-if="channelName === 'LINE'"
           @click="togglePopover">
      <tooltip
        :text="tooltipContent"
        :is-icon="true"
        alignment="top"
        classes="UXicon-rest emojiTooltip"/>
    </v-btn>
    <!--카카오 채널이 아닐 때 노출되는 버튼-->
    <v-btn flat icon color="#FFFFFF"
           class="iconBtn"
           style="opacity: 0.3"
           slot="activator"
           v-else
           :ripple="false">
      <tooltip
        :text="tooltipContent"
        :is-icon="true"
        alignment="top"
        classes="UXicon-rest emojiTooltip"/>
    </v-btn>
    <transition name="vue-swatches-show-hide">
      <div v-show="isOpen" class="emojiPopup">
        <ul class="kakao" v-if="channelName === 'KAKAO_TALK'">
          <li
            v-for="(emoji, index) in kakaoEmoji.emojiSet"
            :key="index"
            @click="addToChatMessageInput(emoji.name, emoji.id)"
            :style="{backgroundPosition: emoji.position}">
          </li>
        </ul>
        <ul class="line" v-else-if="channelName === 'LINE'">
          <li
            v-for="(emoji, index) in lineEmoji.emojiSet"
            :key="index"
            @click="addToChatMessageInput(emoji.name, emoji.id)"
            :style="{backgroundPosition: emoji.position}">
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import eventBus from '@/event_bus'
import {kakaoEmoji} from './kakao_emoji'
import {lineEmoji} from './line_emoji'
import Tooltip from '../../../tooltip'

export default {
  name: 'emoji_picker',
  components: {Tooltip},
  data () {
    return {
      internalIsOpen: false,
      internalValue: this.value,
      kakaoEmoji,
      lineEmoji,
      tooltipContent: `<div>😀 絵文字ショートカットキー<br/>-<strong> Windows : </strong>【Windowsロゴ】+【.】または Windowsロゴ】+【;】<br/>-<strong>Mac : </strong>【control】+【command】+【スペースバー】</div>`
    }
  },
  props: {
    chatRoomId: {
      type: Number,
      default: -1
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    channelName: {
      type: String,
      default: null
    },
    isPermission: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    }
  },
  methods: {
    addToChatMessageInput (emojiName, emojiId) {
      let emoji = '(' + emojiName + ')'
      if (this.chatRoomId > 0) {
        eventBus.$emit(`add-emoji-to-message-input-${this.chatRoomId}`, emoji, emojiId)
      }
    },
    onBlur (relatedTarget) {
      if (!this.isOpen) return
      if (relatedTarget !== null && this.$el.contains(relatedTarget)) return
      this.internalIsOpen = false
      this.$emit('close', this.internalValue)
    },
    togglePopover () {
      this.isOpen ? this.hidePopover() : this.showPopover()
    },
    hidePopover () {
      this.internalIsOpen = false
      this.$el.blur()
      this.$emit('close', this.internalValue)
    },
    showPopover () {
      if (this.isOpen || this.disabled) return
      this.internalIsOpen = true
      this.$el.focus()
      this.$emit('open')
    }
  },
  computed: {
    isOpen () {
      return this.internalIsOpen
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/emoji_picker.vue